import React from 'react';
import moment from 'moment';
import SVGIcon from 'src/components/svg';
import HomeLeft from 'src/components/HomeLeft';

import { scssVariables as variables, remCss, lang } from 'src/helpers';

import Login from 'src/pages/admin/auth/Login';
import ForgotPw from 'src/pages/public/Password/ForgotPw';
import ResetPw from 'src/pages/public/Password/ResetPw';

const footer = (
  <div style={{ marginBottom: remCss(20) }}>
    © {moment().format('YYYY')}. {lang.t('All rights reserved.')}
  </div>
);
const style = {};
style.backgroundColor = variables['colors-mc-white'];

const AuthContainer = React.memo(({ children }) => (
  <div className={'mc-page-auth'} style={style}>
    <HomeLeft footer={footer} />
    <div className={'mc-page-auth-content'}>
      <div className={'mc-page-auth-wrap'}>{children}</div>
    </div>
    <div className={'mc-page-auth-image-bottom'}>
      <SVGIcon iconname={'login-rb-icon'} />
    </div>
  </div>
));
AuthContainer.displayName = 'AuthContainer';

export default {
  ADMIN_LOGIN_PAGE: {
    name: 'admin_login_page',
    path: '/admin/login',
    element: (
      <AuthContainer>
        <Login />
      </AuthContainer>
    )
  },
  ADMIN_FORGOT_PASSWORD_PAGE: {
    path: '/admin/forgot-pw',
    element: (
      <AuthContainer>
        <ForgotPw />
      </AuthContainer>
    )
  },
  ADMIN_RESET_PASSWORD_PAGE: {
    path: '/admin/reset-pw',
    element: (
      <AuthContainer>
        <ResetPw />
      </AuthContainer>
    )
  }
};
